<template>
  <benefit-notification-box-base :icon-path="'subscription/discount.svg'" :description="description" :title="title"/>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BenefitNotificationBoxBase from '@/base-components/BenefitNotificationBoxBase';

export default {
  name: 'FreeMonthsBenefitNotificationBox',
  components: {
    BenefitNotificationBoxBase,
  },
  computed: {
    ...mapState('benefits', ['benefitType', 'benefitAmount']),
    ...mapGetters('benefits', ['BENEFIT_TYPES']),
    title() {
      return 'מגיע לך חודש מנוי במתנה!';
    },
    description() {
      return 'נרשמים לחודש מנוי בתשלום ולאחריו נהנים מחודש מתנה';
    },
  },
};
</script>

<style scoped lang="scss">
</style>
